export function getCalendarRelieveDayFollowUpLockedKey(followUp) {
  return followUp.isArchived
    ? 'Calendar.ArchivedDueDateKey'
    : 'Calendar.NoEditDueDateKey'
}
